import { clipboard } from "@luce/core";
import { useNavigation } from "@luce/core/adapters/navigation";
import { Box, Divider, Icon, IconButton, Pressable, toast, Typography } from "@luce/ui";

interface InvoiceDocumentRowProps {
  title: string;
  pdfPath: string | null;
}

export function InvoiceDocumentRow({ title, pdfPath }: InvoiceDocumentRowProps) {
  const { push } = useNavigation();

  const onCopy = async () => {
    const result = await clipboard.copy(title);
    if (result.success) toast.success("Copied to clipboard");
  };

  return (
    <Box className="gap-spacing-sm flex flex-col">
      <Box className="gap-spacing-md flex flex-row items-center justify-between">
        <Box className="gap-spacing-xs flex flex-row items-center">
          <Typography variant="label-sm" color="neutral-foreground-default">
            {title}
          </Typography>
          <IconButton
            icon="Copy"
            variant="tertiary"
            size="sm"
            onClick={onCopy}
            accessibilityLabel={`Copy ${title}`}
          />
        </Box>
        {pdfPath && (
          <Pressable
            onClick={() => push(pdfPath)}
            accessibilityRole="link"
            accessibilityLabel={`View PDF for ${title}`}
            className="gap-spacing-xs flex flex-row items-center"
          >
            <Typography variant="body-sm" color="brand-primary">
              View PDF
            </Typography>
            <Icon name="CaretRight" size={16} className="text-luce-brand-primary" />
          </Pressable>
        )}
      </Box>
      <Divider />
    </Box>
  );
}
